import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import CategoryGrid from '../components/profession/CategoryGrid'
import SEO from '../components/layout/SEO'  // Add this import

const ProfessionPage = () => {
  React.useEffect(() => {
    document.body.style.paddingTop = '0'
    return () => {
      document.body.style.paddingTop = '0'
    }
  }, [])

  return (
    <HelmetProvider>
      <div className="profession-page" style={{
  marginTop: '50px' 
}}
>
        <SEO 
          title="Profession Categories - Resumeslip"
          description="Choose from hundreds of professional resume templates categorized by profession. Build resumes for every career path."
          keywords="profession categories, resume by profession, career templates, job categories"
        />
        <CategoryGrid />
      </div>
    </HelmetProvider>
  )
}

export default ProfessionPage